/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .az-card{display:block}[_nghost-%COMP%]     .mat-card-content, [_nghost-%COMP%]     .mat-card-header .mat-card-title, [_nghost-%COMP%]     .mat-card-subtitle{font-size:17px}[_nghost-%COMP%]     allianz_logo{src:url(Allianzlogo.798fd23b9101fbf73d98.png);float:right;width:200px}"];
export { styles as styles };
